import React from "react";
import classNames from "classnames";

/* ---------- Types ---------- */

interface CommonStatusBadgeProps {
  isActive?: boolean;
  activeText?: string;
  inactiveText?: string;
  activeColor?: string;
  inactiveColor?: string;
  className?: string;
  style?: React.CSSProperties;
}

/* ---------- Component ---------- */

const CommonStatusBadge: React.FC<CommonStatusBadgeProps> = ({
  isActive = true,
  activeText = "Active",
  inactiveText = "Inactive",
  activeColor = "success",
  inactiveColor = "secondary",
  className = "",
  style = {},
}) => {
  return (
    <span
      className={classNames(
        "badge",
        `bg-${isActive ? activeColor : inactiveColor}`,
        "px-2 fw-semibold",
        className
      )}
      style={{
        fontSize: "12px",
        letterSpacing: "0.3px",
        borderRadius: "8px",
        width: "65px",
        ...style,
      }}
    >
      {isActive ? activeText : inactiveText}
    </span>
  );
};

export default CommonStatusBadge;
